import React, { useState, useEffect, useRef } from "react";
import Modal from "../Modpages/Modal";
import '../Founders/FounderCard.css'; 

const FounderCard = ({ image, name, header, descr, cnt }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cardRef = useRef();
  const imgRef = useRef();

  // Scroll Animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          cardRef.current.classList.add("show");
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(cardRef.current);
  }, []);

  // Parallax Effect (NO BLUR)
  const handleMouseMove = (e) => {
    const rect = cardRef.current.getBoundingClientRect();

    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    const moveX = (x - 0.5) * 10;
    const moveY = (y - 0.5) * 10;

    imgRef.current.style.transform = `translate(${moveX}px, ${moveY}px) scale(1.03)`;
  };

  const handleMouseLeave = () => {
    imgRef.current.style.transform = "translate(0,0) scale(1)";
  };

  return (
    <>
      <div
        ref={cardRef}
        className="founder-card-ultra"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        {/* Image */}
        <div className="founder-img-box">
          <img ref={imgRef} src={image} alt={name} />
        </div>

        {/* Content */}
        <div className="founder-content">
          <h2>{name}</h2>
          <h4>{header}</h4>
          <p>{descr}</p>

          <button onClick={() => setIsModalOpen(true)}>
            Read More...
          </button>
        </div>
      </div>

      {/* Modal */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} dialogClassName="custom-modal">
        <h2 className="headname">{name}</h2>
        <h4 className="headdesig">{header}</h4>
        <hr />

        {cnt === "O3" && (
            <div className="paratxt">
            <p style={{ whiteSpace: "pre-line" }}>
              <b style={{color: "red"}}>Greetings to All,</b> 
              {"\n"}{"\n"} <b>"If a man does not know to what part he is steering no wind is favourable".</b>
              {"\n"}{"\n"} This was said by the ancient philosopher,Seneca. The present world is changing rapidly and the education which we provide to our childreen should help them to achieve their dreams and goals. The students of today are more creative,as they are surviving in the world of technology. if a child has creative thinking though it is a unique gift of nature, a highly valued human quality which has been known for a long time to have it's influence on scientific, technological and artistic spheres of human activity. The rapidly changing demands and challenges existing in the world today have almost necessarily been accompanied by creative expression and contribution from talented people. The main aim of education is the all round development of an individual and this helps the child to develop a flexibility to attain an excellent adjustment in the society. School play a vital role to develop creativity among the children . it not only involves certain learnable skills that can be taught but that you must invest all off yourself in forming and delivering really new and valuable .Every child is creative in his own way . With these thoughts NPCA is always providing education to the children as we believe that the real meaning of learning is "bringing out the treasure within" and the vital role of NPCA is to bring out the potential of our students.
              {"\n"}{"\n"} On behalf of the Magazine Team ,I would like to thank everybody who contributed to it. I hope that you all enjoy reading the "NORTHANIAN"</p>
            </div>
          )}

        {cnt === "O4" && (
            <div className="paratxt">
            <p style={{ whiteSpace: "pre-line" }}>
            <b style={{color: "red"}}>Greetings to All,</b>
            {"\n"}{"\n"}   It cultivates and develops the values, which make them grow to be a proud member of a civilized society. 
            {"\n"}{"\n"}<b>“What makes a child gifted and talented may not always be good grades in school, but a different way of 
            looking at the world and learning” - Chuck Grasslay</b>
            {"\n"}{"\n"}North Point Children’s Academy is highly committed to inculcate a state of contentment and happiness in every
             child to ensure a peace loving and harmonious world. The Northanian is an epitome of perfection from the origin of a rural 
             background to a polished individual on his leaving this Treasure Trove of complete education. They are a blend of virtues, 
             wisdom and have imbibed these qualities. As Albert Einstein rightly said “ Education is not the learning of facts but 
             he training of the mind to think”. We strongly believe in this. So we teach with the aim and objective to develop the
              cognitive, curative, affective intelligence of the child but that is not possible without the support of the parents.
              Today’s education is not confined to the academic only, but the all round development of the child is a requisite, 
              keeping this objective in mind, the school provides ample positive challenging activities for the students so their 
              true talents and skills should explore. To meet today’s challenges we equip our children in modern technique of 
              education and the teachers are armed& skillful with it. At NPCA, we are always guided by our school motto 
              “Vidhya Param Bhushanam” ,”Education is the biggest ornamental of an individual”. If a child is decorated with quality 
              education blended with value, ethics and moral, they does not requireany kind of ornament to shine. The fragrance of 
              their knowledge spreads far and wide. Nothing can give happiness rather than to see the success of our children. 
              It gives us a sense of pride when we see our children touching great heights in their life keeping all the values 
              and ethics that was inculcated during their childhood. I am thankful to our parents who walked with us in this 
              journey of transforming a blooming bud into a true global citizen. As a Principal, I would like to personally 
              welcome you all to our Northanian family. Together, we will make the journey of your child fruitful and successful 
              in every sphere of life. So good luck and enjoy truly. “And see the Sun himself on wings of glory up the east the 
              springs, Angel of light”.
              {"\n"}{"\n"}With warm regards, 
              {"\n"} <b style={{color: "red"}}>Dr. Kirtima Upadhyay</b></p>
            </div>
          )}
      </Modal>
    </>
  );
};

export default FounderCard;